import {Component, inject, Input, OnChanges, SimpleChanges} from '@angular/core';
import {MaterialModule} from '../../../../material.module';
import {
  ConfiguredFunctionConflictKind,
  ConfiguredFunctionSelection,
  IConfiguredFunctionManifest,
  IConfiguredFunctionManifestEntry
} from '../../../../models/function-options.model';
import {FunctionsService} from '../../../../services/objects/functions.service';

@Component({
  selector: 'app-assistant-function-manifest-preview',
  standalone: true,
  imports: [MaterialModule],
  templateUrl: './assistant-function-manifest-preview.component.html',
  styleUrl: './assistant-function-manifest-preview.component.scss'
})
export class AssistantFunctionManifestPreviewComponent implements OnChanges {
  private readonly functionsService = inject(FunctionsService);
  private requestSequence = 0;

  @Input() assistantId = '';

  manifest: IConfiguredFunctionManifest | null = null;
  isLoading = false;
  loadFailed = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['assistantId']) return;

    this.requestSequence++;
    this.manifest = null;
    this.loadFailed = false;
    this.isLoading = false;
    if (this.assistantId) this.refresh();
  }

  refresh(): void {
    const assistantId = this.assistantId;
    if (!assistantId) return;

    const request = ++this.requestSequence;
    this.isLoading = true;
    this.loadFailed = false;
    this.functionsService.getManifestAsync(assistantId).subscribe({
      next: manifest => {
        if (request !== this.requestSequence || assistantId !== this.assistantId) return;
        this.manifest = manifest;
        this.isLoading = false;
      },
      error: () => {
        if (request !== this.requestSequence || assistantId !== this.assistantId) return;
        this.manifest = null;
        this.loadFailed = true;
        this.isLoading = false;
      }
    });
  }

  selectionLabel(selection: ConfiguredFunctionSelection): string {
    if (selection === 'Explicit' || selection === 1) return 'Explicitly selected';
    if (selection === 'ImplicitProduct' || selection === 2) return 'Implicit product selection';
    return 'Not selected';
  }

  conflictLabel(kind: ConfiguredFunctionConflictKind): string {
    if (kind === 'DuplicateNormalizedToolName' || kind === 0) return 'Duplicate tool name';
    if (kind === 'DescriptionOverlap' || kind === 1) return 'Description overlap';
    if (kind === 'SchemaPropertyOverlap' || kind === 2) return 'Schema property overlap';
    return 'Potential conflict';
  }

  entryKey(entry: IConfiguredFunctionManifestEntry): string {
    return `${entry.functionId}:${entry.version}`;
  }
}
